import FetchHelpers from '../../../utils/FetchHelpers';
import formUrl from '../../../utils/routes';
import { decamelize } from '../../../utils/keysConverter';

export default {
  load(params) {
    const url = formUrl('/api/v1/admin/stores/cashback_rates');

    return FetchHelpers.get(url, decamelize(params));
  },
  update(params) {
    const url = formUrl(`/api/v1/admin/stores/change_cashback_rate`);

    return FetchHelpers.put(url, params);
  },
};
